// WorkflowPipeline — render a fixed multi-stage lifecycle (eSAAR 15-state,
// briefing, feedback, gate) as a horizontal chevron ribbon. Preserves
// denied/returned as a distinct "blocked" tone instead of collapsing to pending.
// Reuses the existing .chevron-step primitive (done / active / blocked).

import './redesign.css';

const STEP_CLASS = {
  done: 'chevron-step done',
  active: 'chevron-step active',
  blocked: 'chevron-step blocked',
  pending: 'chevron-step',
};

export function WorkflowPipeline({ steps = [], ariaLabel = 'Workflow progress' }) {
  return (
    <div className="workflow-pipeline" role="list" aria-label={ariaLabel}>
      {steps.map((s, i) => (
        <span
          key={s.key || s.label || i}
          role="listitem"
          className={STEP_CLASS[s.status] || STEP_CLASS.pending}
          aria-current={s.status === 'active' ? 'step' : undefined}
          title={s.title || s.label}
          data-status={s.status || 'pending'}
        >
          {s.label}
        </span>
      ))}
    </div>
  );
}

// Build steps from a canonical ordered state list + the current state.
// `statusByKey` lets callers force a step to 'blocked' (denied/returned) etc.
export function buildPipelineSteps({ order = [], current, statusByKey = {}, labels = {} }) {
  const idx = order.indexOf(current);
  return order.map((key, i) => {
    const forced = statusByKey[key];
    let status = forced;
    if (!status) {
      if (idx < 0) status = 'pending';
      else if (i < idx) status = 'done';
      else if (i === idx) status = 'active';
      else status = 'pending';
    }
    return { key, label: labels[key] || key, status };
  });
}
